import { render, staticRenderFns } from "./CaseUpdate.vue?vue&type=template&id=0b3f6979&scoped=true&"
import script from "./CaseUpdate.vue?vue&type=script&lang=ts&"
export * from "./CaseUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./CaseUpdate.vue?vue&type=style&index=0&id=0b3f6979&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3f6979",
  null
  
)

export default component.exports